import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as SX from './sx';
import type { CurrentPlanTagProps as Props } from './types';
import { Label } from '@aibees/shared/components';

export const CurrentPlanTag = memo(({ className }: Props) => {
  const { selectedPlan, currentPlan, isPaid } = usePlanCardContext();
  if (
    (isPaid && currentPlan?.id !== selectedPlan?.id) ||
    (!isPaid && currentPlan?.metadata.is_free !== 'true')
  )
    return null;

  return (
    <Label
      className={classnames('CurrentPlanTag', className)}
      sx={SX.root}
      variant="soft"
      color="success"
      size="xsmall"
    >
      Current Plan
    </Label>
  );
});

CurrentPlanTag.displayName = 'CurrentPlanTag';
